import { __assign, __read, __spreadArray } from 'tslib';
import { useRef, useState, useEffect } from 'react';
import '../../hooks/useDetectInputMethod.js';
import { useId } from '@reach/auto-id';
import '@emotion/react';
import 'lodash.get';
import '@compono/ui-theme';
import 'deepmerge';
import '@emotion/is-prop-valid';
import { useUpdateEffect } from '../../hooks/useUpdateEffect/index.js';
import eachWeekOfInterval from '../../node_modules/date-fns/esm/eachWeekOfInterval/index.js';
import eachDayOfInterval from '../../node_modules/date-fns/esm/eachDayOfInterval/index.js';
import endOfWeek from '../../node_modules/date-fns/esm/endOfWeek/index.js';
import subYears from '../../node_modules/date-fns/esm/subYears/index.js';
import addYears from '../../node_modules/date-fns/esm/addYears/index.js';
import setMonth from '../../node_modules/date-fns/esm/setMonth/index.js';
import getMonth from '../../node_modules/date-fns/esm/getMonth/index.js';
import setDate from '../../node_modules/date-fns/esm/setDate/index.js';
import getDate from '../../node_modules/date-fns/esm/getDate/index.js';
import format from '../../node_modules/date-fns/esm/format/index.js';
import eachYearOfInterval from '../../node_modules/date-fns/esm/eachYearOfInterval/index.js';
import setYear from '../../node_modules/date-fns/esm/setYear/index.js';
import getYear from '../../node_modules/date-fns/esm/getYear/index.js';
import subMonths from '../../node_modules/date-fns/esm/subMonths/index.js';
import min from '../../node_modules/date-fns/esm/min/index.js';
import addMonths from '../../node_modules/date-fns/esm/addMonths/index.js';
import max from '../../node_modules/date-fns/esm/max/index.js';
import isWithinInterval from '../../node_modules/date-fns/esm/isWithinInterval/index.js';
import startOfYear from '../../node_modules/date-fns/esm/startOfYear/index.js';
import lastDayOfYear from '../../node_modules/date-fns/esm/lastDayOfYear/index.js';
import isBefore from '../../node_modules/date-fns/esm/isBefore/index.js';
import startOfDay from '../../node_modules/date-fns/esm/startOfDay/index.js';
import isAfter from '../../node_modules/date-fns/esm/isAfter/index.js';
import endOfDay from '../../node_modules/date-fns/esm/endOfDay/index.js';
import startOfMonth from '../../node_modules/date-fns/esm/startOfMonth/index.js';
import endOfMonth from '../../node_modules/date-fns/esm/endOfMonth/index.js';
import startOfWeek from '../../node_modules/date-fns/esm/startOfWeek/index.js';
import isSameMonth from '../../node_modules/date-fns/esm/isSameMonth/index.js';

var today = new Date();
var getYears = function (startDate, endDate, focusDate) {
    return eachYearOfInterval({
        start: startDate,
        end: endDate,
    }).map(function (date) { return setYear(focusDate, getYear(date)); });
};
var getMonthWeeks = function (date) {
    var lastDateOfMonth = endOfMonth(date);
    var startDateOfMonth = startOfMonth(date);
    return eachWeekOfInterval({
        start: startDateOfMonth,
        end: lastDateOfMonth,
    });
};
var getMonthDates = function (date) {
    var weeks = getMonthWeeks(date);
    return weeks.map(function (week) {
        return eachDayOfInterval({
            start: week,
            end: endOfWeek(week),
        });
    });
};
var getWeekDayLabels = function (_a) {
    var locale = _a.locale;
    var date = new Date();
    var lastDateOfWeek = endOfWeek(date);
    var startDateOfWeek = startOfWeek(date);
    return eachDayOfInterval({
        start: startDateOfWeek,
        end: lastDateOfWeek,
    }).map(function (d) { return ({
        minimal: format(d, "EEEEE", __assign({}, (locale && { locale: locale }))),
        abbr: format(d, "EEE", __assign({}, (locale && { locale: locale }))),
        full: format(d, "EEEE", __assign({}, (locale && { locale: locale }))),
    }); });
};
var getFocusMonths = function (_a) {
    var focusMonths = _a.focusMonths, focusDate = _a.focusDate, monthNum = _a.monthNum;
    var newMonths = __spreadArray([], __read(focusMonths), false);
    var maxMonth = endOfMonth(max(focusMonths));
    var minMonth = startOfMonth(min(focusMonths));
    if (isSameMonth(addMonths(maxMonth, 1), focusDate)) {
        newMonths.shift();
        newMonths.push(focusDate);
    }
    else if (isSameMonth(subMonths(minMonth, 1), focusDate)) {
        newMonths.pop();
        newMonths.unshift(focusDate);
    }
    else if (focusMonths.length !== monthNum ||
        !isWithinInterval(focusDate, {
            start: minMonth,
            end: maxMonth,
        })) {
        newMonths.splice(0, monthNum);
        for (var i = 0; i < monthNum; i++) {
            newMonths.push(addMonths(focusDate, i));
        }
    }
    return newMonths.map(function (month) {
        return setMonth(setDate(month, getDate(focusDate)), getMonth(month));
    });
};
var useCheckIsDisabled = function (_a) {
    var years = _a.years, disabledBefore = _a.disabledBefore, disabledAfter = _a.disabledAfter;
    return function (date) {
        if (!isWithinInterval(date, {
            start: startOfYear(min(years)),
            end: lastDayOfYear(max(years)),
        }))
            return true;
        if (disabledBefore && isBefore(date, startOfDay(disabledBefore)))
            return true;
        if (disabledAfter && isAfter(date, endOfDay(disabledAfter)))
            return true;
        return false;
    };
};
var useFocusDateElement = function (_a) {
    var mode = _a.mode, datesRef = _a.datesRef, yearsRef = _a.yearsRef;
    return function (date) {
        setTimeout(function () {
            var elem = mode === "month"
                ? datesRef.current[getMonth(date)][getDate(date)]
                : yearsRef.current[getYear(date)];
            (elem === null || elem === void 0 ? void 0 : elem.tabIndex) === 0 && elem.focus();
        });
    };
};
var getDefaultFocusDate = function (_a) {
    var value = _a.value, defaultFocusDate = _a.defaultFocusDate, initialFocusDate = _a.initialFocusDate;
    if (Array.isArray(value)) {
        return (initialFocusDate ||
            (value.length > 0 ? min(value) : defaultFocusDate || new Date()));
    }
    else {
        return initialFocusDate || value || defaultFocusDate || new Date();
    }
};
var useDatePicker = function (props) {
    var _a = props.monthNum, monthNum = _a === void 0 ? 1 : _a, _b = props.defaultMode, defaultMode = _b === void 0 ? "month" : _b, _c = props.startYear, startYear = _c === void 0 ? subYears(today, 100) : _c, _d = props.endYear, endYear = _d === void 0 ? addYears(today, 100) : _d, disabledBefore = props.disabledBefore, disabledAfter = props.disabledAfter, locale = props.locale, id = props.id, onSelect = props.onSelect, selectOnNavigate = props.selectOnNavigate, _e = props.autoFocus, autoFocus = _e === void 0 ? false : _e, value = props.value;
    var yearsRef = useRef([]);
    var datesRef = useRef(Array.from({ length: 13 }, function () { return []; }));
    var _f = __read(useState(getDefaultFocusDate(props)), 2), focusDate = _f[0], setFocusDate = _f[1];
    var _g = __read(useState(), 2), hoverDate = _g[0], setHoverDate = _g[1];
    var _h = __read(useState(false), 2), isHover = _h[0], setIsHover = _h[1];
    var _j = __read(useState(getFocusMonths({ focusDate: focusDate, focusMonths: [], monthNum: monthNum })), 2), focusMonths = _j[0], setFocusMonths = _j[1];
    var _k = __read(useState(defaultMode), 2), mode = _k[0], setMode = _k[1];
    var dayLabels = getWeekDayLabels({ locale: locale });
    var years = getYears(startYear, endYear, focusDate);
    var prevMonth = subMonths(min(focusMonths), 1);
    var nextMonth = addMonths(max(focusMonths), 1);
    var datePickerId = id ? id : "date-picker--".concat(useId());
    var checkIsDisabled = useCheckIsDisabled({
        years: years,
        disabledBefore: disabledBefore,
        disabledAfter: disabledAfter,
    });
    var checkIsInFocusMonths = function (date) {
        return isWithinInterval(date, {
            start: startOfMonth(min(focusMonths)),
            end: endOfMonth(max(focusMonths)),
        });
    };
    var focusDateElement = useFocusDateElement({ mode: mode, datesRef: datesRef, yearsRef: yearsRef });
    var selectDate = function (date, noFocus) {
        if (checkIsDisabled(date))
            return;
        setFocusDate(date);
        onSelect && onSelect(date);
        !noFocus && focusDateElement(date);
    };
    var navigateDate = function (date, noFocus) {
        if (checkIsDisabled(date))
            return;
        setFocusDate(date);
        selectOnNavigate && selectDate(date, true);
        !noFocus && focusDateElement(date);
    };
    useEffect(function () {
        if (mode === "month") {
            setFocusMonths(getFocusMonths({ focusDate: focusDate, focusMonths: focusMonths, monthNum: monthNum }));
        }
    }, [mode, focusDate, monthNum]);
    useUpdateEffect(function () {
        focusDateElement(focusDate);
    }, [mode]);
    useUpdateEffect(function () {
        var newFocusDate = getDefaultFocusDate(props);
        var newFocusMonths = getFocusMonths({
            focusDate: newFocusDate,
            focusMonths: focusMonths,
            monthNum: monthNum,
        });
        setFocusDate(newFocusDate);
        setFocusMonths(newFocusMonths);
    }, [value]);
    useEffect(function () {
        autoFocus && focusDateElement(focusDate);
    }, []);
    return __assign(__assign({}, props), { getMonthDates: getMonthDates, checkIsDisabled: checkIsDisabled, checkIsInFocusMonths: checkIsInFocusMonths, setFocusMonths: setFocusMonths, setFocusDate: setFocusDate, setHoverDate: setHoverDate, setIsHover: setIsHover, setMode: setMode, navigateDate: navigateDate, selectDate: selectDate, focusMonths: focusMonths, focusDate: focusDate, hoverDate: hoverDate, isHover: isHover, mode: mode, yearsRef: yearsRef, datesRef: datesRef, dayLabels: dayLabels, years: years, datePickerId: datePickerId, prevMonth: prevMonth, nextMonth: nextMonth });
};

export { useDatePicker };
//# sourceMappingURL=useDatePicker.js.map
